export enum WebOnlyType {
  True = 'true',
  False = 'false',
  None = 'none',
}
